(function () {
  var configElement = document.getElementById("ps-crisp-local-preform-config");

  if (!configElement) {
    return;
  }

  var config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  window.$crisp = window.$crisp || [];

  var pickerId = config.pickerId || "ps-preform-main";
  var scenarioId = config.scenarioId;
  var segmentPrefix = "ps-preform-";
  var preformShown = false;
  var preformForwarded = false;
  var htmlFallbackShown = false;
  var deferredPickerTimer = null;
  var lastObservedMessageIsPicker = false;
  var PREFORM_SESSION_IDLE_MS = 24 * 60 * 60 * 1000;
  var lastMergedChatActivityWriteMs = null;

  function isCrispSdkReady() {
    return typeof window.$crisp.get === "function" && typeof window.$crisp.is === "function";
  }

  function isChatOpened() {
    if (!isCrispSdkReady()) {
      return false;
    }

    try {
      return window.$crisp.is("chat:opened") === true;
    } catch (error) {
      return false;
    }
  }

  function extractMessageTimeMs(message) {
    if (!message || typeof message !== "object") {
      return null;
    }

    var raw = message.timestamp;

    if (typeof raw === "number") {
      return raw < 1e12 ? raw * 1000 : raw;
    }

    if (typeof raw === "string" && /^\d+$/.test(raw)) {
      var n = parseInt(raw, 10);
      return n < 1e12 ? n * 1000 : n;
    }

    if (message.stamped_at && typeof message.stamped_at === "number") {
      var stamped = message.stamped_at;
      return stamped < 1e12 ? stamped * 1000 : stamped;
    }

    if (typeof message.created_at === "string") {
      var parsed = Date.parse(message.created_at);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }

    return null;
  }

  function mergeAndPersistChatActivityMs(candidateMs) {
    var prev = getLastChatInteractionTimestampMs();
    var prevLocal = lastMergedChatActivityWriteMs;
    var base = candidateMs;

    if (prev != null) {
      base = Math.max(base, prev);
    }

    if (prevLocal != null) {
      base = Math.max(base, prevLocal);
    }

    lastMergedChatActivityWriteMs = base;

    window.$crisp.push(["set", "session:data", [[
      ["ps_preform_last_chat_activity_at", String(base)]
    ]]]);
  }

  function recordVisitorSentMessageActivity() {
    mergeAndPersistChatActivityMs(Date.now());
  }

  function recordIncomingMessageActivity(message) {
    var ts = extractMessageTimeMs(message);

    if (ts == null) {
      return;
    }

    mergeAndPersistChatActivityMs(ts);
  }

  function getChoice(value) {
    for (var i = 0; i < config.choices.length; i++) {
      if (config.choices[i].value === value) {
        return config.choices[i];
      }
    }

    return null;
  }

  function buildPicker() {
    var choices = [];

    for (var i = 0; i < config.choices.length; i++) {
      choices.push({
        value: config.choices[i].value,
        icon: config.choices[i].icon,
        label: config.choices[i].label,
        selected: false
      });
    }

    return {
      id: pickerId,
      text: config.text,
      choices: choices
    };
  }

  function getPreformSegment(value) {
    return segmentPrefix + String(value).replace(/_/g, "-");
  }

  function getLastChatInteractionTimestampMs() {
    var raw = getSessionDataString("ps_preform_last_chat_activity_at");
    if (!raw) {
      return null;
    }

    var parsed = parseInt(raw, 10);

    if (isNaN(parsed)) {
      return null;
    }

    return parsed;
  }

  function getPickerShownTimestampMs() {
    var raw = getSessionDataString("ps_preform_picker_shown_at");
    if (!raw) {
      return null;
    }

    var parsed = parseInt(raw, 10);

    if (isNaN(parsed)) {
      return null;
    }

    return parsed;
  }

  function getLastPreformRelatedInteractionMs() {
    var chatTs = getLastChatInteractionTimestampMs();
    var pickTs = getPickerShownTimestampMs();
    var maxTs = 0;

    if (chatTs != null) {
      maxTs = Math.max(maxTs, chatTs);
    }

    if (pickTs != null) {
      maxTs = Math.max(maxTs, pickTs);
    }

    return maxTs > 0 ? maxTs : null;
  }

  function isSessionBlockedForPreform() {
    if (getSessionDataString("ps_preform_choice")) {
      return true;
    }

    var pending = getSessionDataString("ps_preform_pick_pending");

    return pending === "1" || pending === "true";
  }

  function shouldExpirePreformSessionGates() {
    if (!isSessionBlockedForPreform()) {
      return false;
    }

    var last = getLastPreformRelatedInteractionMs();

    if (last == null) {
      return false;
    }

    return (Date.now() - last) >= PREFORM_SESSION_IDLE_MS;
  }

  function clearPreformSessionGates() {
    window.$crisp.push(["set", "session:data", [[
      ["ps_preform_choice", ""],
      ["ps_preform_label", ""],
      ["ps_preform_pick_pending", "0"],
      ["ps_preform_picker_shown_at", ""]
    ]]]);
  }

  function shouldSkipBecauseRecentPickerInThread() {
    if (!lastObservedMessageIsPicker) {
      return false;
    }

    var last = getLastPreformRelatedInteractionMs();

    if (last == null) {
      return false;
    }

    return (Date.now() - last) < PREFORM_SESSION_IDLE_MS;
  }

  function expirePreformGatesIfIdle() {
    if (!shouldExpirePreformSessionGates()) {
      return;
    }

    clearPreformSessionGates();
  }

  function getSessionDataString(key) {
    try {
      if (typeof window.$crisp.get !== "function") {
        return null;
      }

      var value = window.$crisp.get("session:data", key);

      if (value == null || value === "") {
        return null;
      }

      return String(value);
    } catch (error) {
      return null;
    }
  }

  function shouldSkipPreformFromSession() {
    if (!isCrispSdkReady()) {
      return false;
    }

    if (getSessionDataString("ps_preform_choice")) {
      return true;
    }

    var pending = getSessionDataString("ps_preform_pick_pending");

    return pending === "1" || pending === "true";
  }

  function setSessionPickPending(isPending) {
    var rows = [
      ["ps_preform_pick_pending", isPending ? "1" : "0"]
    ];

    if (isPending) {
      rows.push(["ps_preform_picker_shown_at", String(Date.now())]);
    } else {
      rows.push(["ps_preform_picker_shown_at", ""]);
    }

    window.$crisp.push(["set", "session:data", [rows]]);
  }

  function runPreformWorkflow(value) {
    var choice = getChoice(value);
    var segment = getPreformSegment(value);

    if (preformForwarded || !choice || !scenarioId) {
      return;
    }

    preformForwarded = true;
    removeHtmlFallback();

    window.$crisp.push(["set", "session:segments", [[segment]]]);

    window.$crisp.push(["set", "session:data", [[
      ["ps_preform_choice", value],
      ["ps_preform_label", choice.label],
      ["ps_preform_pick_pending", "0"],
      ["ps_preform_picker_shown_at", ""]
    ]]]);

    window.setTimeout(function () {
      window.$crisp.push(["do", "bot:scenario:run", [
        scenarioId,
        {
          ps_preform_choice: value,
          ps_preform_label: choice.label,
          ps_preform_segment: segment
        }
      ]]);
    }, 300);
  }

  function doShowLocalPickerNow() {
    if (preformShown || preformForwarded) {
      return;
    }

    preformShown = true;

    try {
      window.$crisp.push(["do", "message:show", ["picker", buildPicker()]]);
      setSessionPickPending(true);
    } catch (error) {
      showHtmlFallback();
    }
  }

  function showLocalPicker() {
    if (preformShown || preformForwarded) {
      return;
    }

    expirePreformGatesIfIdle();

    if (shouldSkipPreformFromSession()) {
      preformShown = true;
      return;
    }

    if (deferredPickerTimer != null) {
      return;
    }

    deferredPickerTimer = window.setTimeout(function () {
      deferredPickerTimer = null;

      if (preformShown || preformForwarded) {
        return;
      }

      expirePreformGatesIfIdle();

      if (shouldSkipPreformFromSession()) {
        preformShown = true;
        return;
      }

      if (shouldSkipBecauseRecentPickerInThread()) {
        preformShown = true;
        setSessionPickPending(true);
        return;
      }

      doShowLocalPickerNow();
    }, 120);
  }

  function onCrispReady() {
    if (!isCrispSdkReady()) {
      return false;
    }

    if (isChatOpened()) {
      showLocalPicker();
    }

    return true;
  }

  function showHtmlFallback() {
    if (htmlFallbackShown || preformForwarded) {
      return;
    }

    htmlFallbackShown = true;

    var container = document.createElement("div");
    container.id = "ps-crisp-preform-fallback";
    container.setAttribute("style", [
      "position:fixed",
      "right:20px",
      "bottom:96px",
      "z-index:2147483000",
      "width:320px",
      "max-width:calc(100vw - 40px)",
      "padding:12px",
      "border:1px solid #d8d8d8",
      "border-radius:14px",
      "background:#ffffff",
      "box-shadow:0 12px 30px rgba(0,0,0,.18)",
      "font-family:Arial,sans-serif",
      "font-size:13px",
      "color:#111"
    ].join(";"));

    var title = document.createElement("div");
    title.textContent = config.text;
    title.setAttribute("style", "font-weight:700;margin-bottom:8px;");
    container.appendChild(title);

    for (var i = 0; i < config.choices.length; i++) {
      var choice = config.choices[i];
      var button = document.createElement("button");
      button.type = "button";
      button.setAttribute("data-ps-crisp-preform-value", choice.value);
      button.textContent = choice.icon + " " + choice.label;
      button.setAttribute("style", [
        "display:block",
        "width:100%",
        "margin:6px 0",
        "padding:9px 10px",
        "border:1px solid #111",
        "border-radius:9px",
        "background:#fff",
        "cursor:pointer",
        "font:inherit",
        "text-align:left"
      ].join(";"));
      container.appendChild(button);
    }

    container.addEventListener("click", function (event) {
      var target = event.target;

      if (!target || !target.getAttribute) {
        return;
      }

      var value = target.getAttribute("data-ps-crisp-preform-value");

      if (value) {
        runPreformWorkflow(value);
      }
    });

    document.body.appendChild(container);
    setSessionPickPending(true);
  }

  function removeHtmlFallback() {
    var fallback = document.getElementById("ps-crisp-preform-fallback");

    if (fallback && fallback.parentNode) {
      fallback.parentNode.removeChild(fallback);
    }
  }

  window.$crisp.push(["on", "session:loaded", function () {
    if (isChatOpened()) {
      showLocalPicker();
    }
  }]);

  window.$crisp.push(["on", "message:sent", function () {
    recordVisitorSentMessageActivity();
  }]);

  window.$crisp.push(["on", "message:received", function (message) {
    recordIncomingMessageActivity(message);

    if (message && message.type === "picker") {
      lastObservedMessageIsPicker = true;
    } else if (message && message.type) {
      lastObservedMessageIsPicker = false;
    }

    if (
      message &&
      message.origin === "update" &&
      message.type === "picker" &&
      message.content &&
      message.content.id === pickerId &&
      message.content.choices
    ) {
      for (var i = 0; i < message.content.choices.length; i++) {
        if (message.content.choices[i].selected) {
          runPreformWorkflow(message.content.choices[i].value);
          break;
        }
      }
    }
  }]);

  window.$crisp.push(["on", "chat:initiated", function () {
    showLocalPicker();
  }]);

  window.$crisp.push(["on", "chat:opened", function () {
    showLocalPicker();
  }]);

  var previousReadyTrigger = window.CRISP_READY_TRIGGER;
  window.CRISP_READY_TRIGGER = function () {
    onCrispReady();

    if (typeof previousReadyTrigger === "function") {
      previousReadyTrigger();
    }
  };

  var readyCheckInterval = window.setInterval(function () {
    onCrispReady();

    if (preformShown || preformForwarded) {
      window.clearInterval(readyCheckInterval);
    }
  }, 250);
}());
